import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { t } from '../../../modules/infra/i18n';
import Layout from './components/Layout';
import Report from './productSalesReport/report';
import Filters from './filters/FiltersContainer';
import BrandFilter from './filters/BrandFilterContainer';
import ExportableReport from './ExportableReport';
import BarberFilter from './barbersReport/barberFilterContainer';
import resetFiltersHoc from './hoc/resetFiltersHoc';

function ProductSalesReport({ downloadCsv, canLoadReport }) {
  return (
    <Layout title={t('reports:product_sales_report.title')}>
      <Filters
        csv={downloadCsv}
        disableBarberFilter
        showCsvExport={canLoadReport}
      >
        <div className="c-form-input-group__item u-visible-for-large-and-up">
          <div className="c-label u-ml--">
            {t('reports:filter_by_barber')}
          </div>
          <BarberFilter
            showUnassigned
          />
        </div>
        <BrandFilter />
      </Filters>
      <ExportableReport
        canLoadReport={canLoadReport}
        name="sales-products-report"
        label={t('reports:product_sales_report.title')}
      >
        <Report />
      </ExportableReport>
    </Layout>
  );
}

const mapStateToProps = state => ({
  shop: state.auth.shop,
  csv: state.reports.csv,
});

ProductSalesReport.propTypes = {
  canLoadReport: PropTypes.bool.isRequired,
  downloadCsv: PropTypes.func.isRequired,
};

export default compose(
  resetFiltersHoc,
  connect(mapStateToProps)
)(ProductSalesReport);
